import React, { createContext, useState, useEffect, useContext } from "react";
import { ProfileService } from "../services/ProfileService";
import { AuthContext } from "./AuthContext";

export const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const { isAuthenticated } = useContext(AuthContext); // 로그인 상태 확인

  useEffect(() => {
     if (!isAuthenticated) return; // 로그인하지 않았으면 fetch 안 함
  
    const fetchProfile = async () => {
      const data = await ProfileService.getProfile();
      setProfile(data);
    };

    fetchProfile();
  }, [isAuthenticated]);

  const updateProfile = async (updatedProfile) => {
    try {
      const updatedData = await ProfileService.updateProfile(updatedProfile);
      setProfile(updatedData);
    } catch (error) {
      console.error("Error updating profile data:", error);
    }
  };

  return <ProfileContext.Provider value={{ profile, setProfile, updateProfile }}>{children}</ProfileContext.Provider>;
};
